// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2bufk","options":"AnswerScale_options__2v5D5","selected":"AnswerScale_selected__2Rhuy"};